import './share.css';
import validator from 'validator';
import { useConfettiText } from '../../hooks/useConfettiText';
import ShareJGButton from '../shareJGButton/ShareJGButton';
import { uploadProgress } from '../../utils/uploadProgress'; // (may still be used elsewhere)
import isVideoFile from '../../utils/isVideoFile';
import EmojiEventsOutlinedIcon from '@mui/icons-material/EmojiEventsOutlined';
import getAddressFromCoordinates from '../../utils/getAddressFromCoordinates';
import { PermMedia, Cancel, Room } from '@material-ui/icons';
import {
  useEffect,
  useContext,
  useRef,
  useState,
  useCallback,
  memo,
  useMemo,
} from 'react';
import { createPortal } from 'react-dom';

import { AuthContext } from '../../context/AuthContext';
import axios from 'axios';
import axiosConn from '../../axiosConn';
import useMobileView from '../../hooks/useMobileView';
import Picker from 'emoji-picker-react';
import { ClipLoader } from 'react-spinners';
import ShareOutlinedIcon from '@mui/icons-material/ShareOutlined'; // (possibly unused)
import { getLocationAndSave } from '../../utils/locationUtil';
import arePropsEqual from '../../arePropsEqual';

import { CircularProgress } from '@material-ui/core';
import LoadingBar from 'react-top-loading-bar';
import { ViewPortContext } from '../../context/ViewPortContext';
import { SocketContext } from '../../context/socket';
import { MAX_VIDEO_SIZE, MAX_IMAGE_SIZE } from '../../config/constants';
import { useSuspension } from '../../context/SuspensionContext';
import { handleSuspension } from '../../utils/suspensionUtil';
import { useTheme } from '../../context/ThemeContext';
import {
  usdJGKConversionRate,
  sendReferralEmailJGKRate,
} from '../../utils/config';
import CloseIcon from '@mui/icons-material/Close';
import EasyEdit from 'react-easy-edit';

// === New unified media uploader util ===
import {
  createMediaUploader,
  isSupportedFileType as isSupportedFileTypeUtil,
  computeFileLimit,
  formatBytes,
} from '../../utils/mediaUpload';

const LEGACY_MAX_IMAGE_SIZE = MAX_IMAGE_SIZE;
const ENHANCED_MAX_VIDEO_SIZE = 500 * 1024 * 1024; // preserved constants
const ENHANCED_MAX_IMAGE_SIZE = 40 * 1024 * 1024;
const SHAREJGBUTTON_PARTICLE_COUNT = 2000;
const MESSAGE_PARTICLE_COUNT = 1000;

const FILE_ACCEPT = [
  '.jpg',
  '.jpeg',
  '.png',
  '.gif',
  '.webp',
  '.avif',
  '.heic',
  '.heif',
  '.mp4',
  '.m4v',
  '.webm',
  '.ogg',
  '.ogv',
  '.mov',
  '.flv',
  '.3gp',
  '.3g2',
  '.avi',
  '.mkv',
].join(',');

const MAX_MEDIA_COUNT = 10;

export default memo(function Share({
  setNewPost = () => {}, // ✅ no-op default
  parent = '',
  galaxyId = '',
  isGalaxyMember = false,
  subscriptionStatus = 'Subscribe',
  // NEW (optional) composer prefill hooks:
  initialDesc = '',
  forcedImgUrl = '',
  onSubmitSuccess,
}) {
  const { player } = useContext(AuthContext);
  const desc = useRef();
  const nameRef = useRef();
  const emailRef = useRef();
  const fileInput = useRef(null);
const isVideoSrc = (src = '') =>
  /\.(mp4|webm|ogg|m4v|mov|avi|mkv)(\?|#|$)/i.test(src);

  const [descr, setDescr] = useState(initialDesc || '');
  const [namer, setNamer] = useState('');
  const [emailr, setEmailr] = useState('');
  const [files, setFiles] = useState([]); // [{ file, preview, isVideo }]
  const [error, setError] = useState('');
  const [uploadPercentage, setUploadPercentage] = useState(0);
  const [progress, setProgress] = useState(0);
  const [loading, setLoading] = useState(false);
  const [shareJG, setShareJG] = useState(0);
  const [readyToShareJG, SetReadyToShareJG] = useState(false);
  const [pogw, SetPogw] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const [location, setLocation] = useState(null);
  const [latitude, SetLatitude] = useState(null);
  const [longitude, SetLongitude] = useState(null);
  const [accuracy, SetAccuracy] = useState(null);
  const [timestamp, SetTimestamp] = useState(null);
  const [address, setAddress] = useState(null);
  const [uiProgress, setUiProgress] = useState(0);

  // Emoji picker
  const emojiBtnRef = useRef(null);
  const pickerRef = useRef(null);
  const [picker, setPicker] = useState(false);
  const [pickerPos, setPickerPos] = useState({
    top: 0,
    left: 0,
    placement: 'below',
  });

  const clamp = (v, min, max) => Math.min(Math.max(v, min), max);
  const [shareTimestamps, setCommentTimestamps] = useState([]);
  const SHARE_LIMIT = 5;
  const TIME_FRAME = 60000;
  const SUSPENSION_TIME = 3600000;
  const shareRef = useRef(null);
  const dndRef = useRef(null);

  const { width } = useContext(ViewPortContext);
  const { socket: socket2 } = useContext(SocketContext);
  const { isSuspended, setIsSuspended } = useSuspension();
  const { darkTheme } = useTheme();
  const mobileView = useMobileView();

  const handleShareJGToggle = () => setShareJG((p) => (p === 0 ? 1 : 0));
  const [galaxyMember, setGalaxyMember] = useState(isGalaxyMember);
  const [isDisabled, setIsDisabled] = useState(
    parent === 'galaxy' && subscriptionStatus !== 'Subscribed',
  );

  useEffect(() => {
    // keep it one-way (only set on open/mount)
    setDescr(initialDesc || '');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialDesc]);

  useEffect(() => setGalaxyMember(isGalaxyMember), [isGalaxyMember]);
  useEffect(() => {
    setIsDisabled(parent === 'galaxy' && subscriptionStatus !== 'Subscribed');
  }, [parent, galaxyMember, subscriptionStatus]);

  const [cursorPosition, setCursorPosition] = useState();
  useEffect(() => {
    if (cursorPosition && desc.current) {
      desc.current.selectionStart = cursorPosition;
      desc.current.selectionEnd = cursorPosition;
    }
  }, [cursorPosition]);

  const positionEmojiPicker = useCallback(() => {
    if (!emojiBtnRef.current || !pickerRef.current) return;
    const btn = emojiBtnRef.current.getBoundingClientRect();
    const pickerEl = pickerRef.current;
    const pw = pickerEl.offsetWidth || 320;
    const ph = pickerEl.offsetHeight || 360;
    const margin = 12;
    let placement = 'below';
    let top = btn.bottom + margin;
    if (
      btn.bottom + margin + ph > window.innerHeight &&
      btn.top - margin - ph > 0
    ) {
      placement = 'above';
      top = btn.top - margin - ph;
    }
    let left = btn.left + btn.width / 2 - pw / 2;
    left = clamp(left, 8, window.innerWidth - pw - 8);
    setPickerPos({ top, left, placement });
  }, []);

  useEffect(() => {
    if (!picker) return;
    requestAnimationFrame(positionEmojiPicker);
    const handle = () => positionEmojiPicker();
    window.addEventListener('resize', handle);
    window.addEventListener('scroll', handle, true);
    return () => {
      window.removeEventListener('resize', handle);
      window.removeEventListener('scroll', handle, true);
    };
  }, [picker, positionEmojiPicker]);

  useEffect(() => {
    if (!picker) return;
    const onKey = (e) => e.key === 'Escape' && setPicker(false);
    const onClick = (e) => {
      if (
        pickerRef.current &&
        !pickerRef.current.contains(e.target) &&
        emojiBtnRef.current &&
        !emojiBtnRef.current.contains(e.target)
      ) {
        setPicker(false);
      }
    };
    window.addEventListener('keydown', onKey);
    window.addEventListener('mousedown', onClick);
    return () => {
      window.removeEventListener('keydown', onKey);
      window.removeEventListener('mousedown', onClick);
    };
  }, [picker]);

  const handleEmoji = (_, { emoji }) => {
    const ref = desc.current;
    ref.focus();
    const start = ref.value.substring(0, ref.selectionStart);
    const end = ref.value.substring(ref.selectionStart);
    setDescr(start + emoji + end);
    setCursorPosition(start.length + emoji.length);
  };

  const [showConfettiText, ConfettiTextComponent] = useConfettiText(
    shareRef,
    mobileView,
    '+10 JGK Win!',
    MESSAGE_PARTICLE_COUNT,
    'share',
  );
  const inputRef2 = useRef(null);
  const [showConfettiText2, ConfettiTextComponent2] = useConfettiText(
    inputRef2,
    mobileView,
    '+20 JGK Big Play!',
    SHAREJGBUTTON_PARTICLE_COUNT,
    'shareJGButton',
    false,
  );

  const resetForm = useCallback(() => {
    setDescr('');
    setNamer('');
    setEmailr('');
    SetReadyToShareJG(false);
    setShareJG(0);
    setIsFetching(false);
    // cleanup previews
    files.forEach((f) => {
      if (f.preview && f.preview.startsWith('blob:')) {
        URL.revokeObjectURL(f.preview);
      }
    });
    setFiles([]);
    setUploadPercentage(0);
    setProgress(0);
    if (fileInput.current) fileInput.current.value = null;
  }, [files]);

  const shareJGChecker = () => {
    if (
      validator.isAlpha(namer || '', 'en-US', { ignore: ' -' }) &&
      validator.isEmail(emailr || '')
    ) {
      SetReadyToShareJG(true);
    } else SetReadyToShareJG(false);
  };
  useEffect(shareJGChecker, [namer, emailr]);

  // Cleanup previews on unmount
  useEffect(
    () => () => {
      files.forEach((f) => {
        if (f.preview && f.preview.startsWith('blob:')) {
          URL.revokeObjectURL(f.preview);
        }
      });
    },
    [files],
  );

  // === Unified uploader (singleton per component instance) ===
  const uploaderRef = useRef(null);
  if (!uploaderRef.current) {
    uploaderRef.current = createMediaUploader({
      axiosInstance: axios,
      // Keep size limits consistent with existing enhanced logic
      maxImageBytes: ENHANCED_MAX_IMAGE_SIZE,
      maxVideoBytes: ENHANCED_MAX_VIDEO_SIZE,
      // chunk threshold & size same as prior logic
      chunkThresholdBytes: 90 * 1024 * 1024,
      chunkSizeBytes: 20 * 1024 * 1024,
    });
  }
  const uploader = uploaderRef.current;

  // Preserve enhanced size label logic using util for accuracy
  const enhancedSizeLabel = (f) => {
    if (!f) return '';
    const limit = computeFileLimit(f, {
      maxImageBytes: ENHANCED_MAX_IMAGE_SIZE,
      maxVideoBytes: ENHANCED_MAX_VIDEO_SIZE,
    });
    return formatBytes(limit);
  };

  // Build transformed URL already handled inside util (transformedUrl).
  // createPost / createGalaxyPost remain unchanged other than using imgUrl.

  const createGalaxyPost = async (imgUrl, mediaUrls = []) => {
    try {
      const postData = {
        playerId: player.data.player.playerId,
        desc: descr,
        img: imgUrl,
        media: mediaUrls,
        isPogw: pogw,
      };
      if (longitude !== null) postData.longitude = longitude;
      if (latitude !== null) postData.latitude = latitude;
      if (accuracy !== null) postData.accuracy = accuracy;
      if (timestamp !== null) postData.timestamp = timestamp;
      if (address !== null) postData.address = address;

      const res = await axiosConn.post(
        `/galaxies/${galaxyId}/posts`,
        postData,
        {
          headers: { Authorization: `Bearer ${player.token}` },
        },
      );
      setNewPost(res.data.post);
      showConfettiText();
      socket2.emit('sendPost', { post: res.data.post });
    } catch (err) {
      if (err.response && err.response.status === 403) {
        setError('You must be a Galaxy member to create a Galaxy Post');
      } else setError('Unexpected error creating Galaxy Post');
    }
  };

  const createPost = async (imgUrl, mediaUrls = []) => {
    const postData = {
      playerId: player.data.player.playerId,
      desc: descr,
      img: imgUrl,
      media: mediaUrls,
      isPogw: pogw,
    };
    if (longitude !== null) postData.longitude = longitude;
    if (latitude !== null) postData.latitude = latitude;
    if (accuracy !== null) postData.accuracy = accuracy;
    if (timestamp !== null) postData.timestamp = timestamp;
    if (address !== null) postData.address = address;

    const res = await axiosConn.post('posts', postData, {
      headers: { Authorization: `Bearer ${player.token}` },
    });
    setNewPost(res.data.data.data);
    showConfettiText();
    socket2.emit('sendPost', { post: res.data.data.data });
  };

  const handleClearLocation = () => {
    SetLatitude(null);
    SetLongitude(null);
    SetAccuracy(null);
    SetTimestamp(null);
    setAddress('');
  };
  const handleGetLocation = async () => {
    try {
      await getLocationAndSave(
        SetLatitude,
        SetLongitude,
        SetAccuracy,
        SetTimestamp,
        player,
      );
    } catch (e) {
      console.error('Location error', e);
    }
  };

  useEffect(() => {
    const fetchAddress = async () => {
      if (latitude !== null && longitude !== null) {
        try {
          const {
            city,
            region: state,
            country,
          } = await getAddressFromCoordinates(latitude, longitude);
          const formatted = [city, state, country].filter(Boolean).join(', ');
          setAddress(formatted);
        } catch (e) {
          console.error('Reverse geocode error', e);
        }
      }
    };
    fetchAddress();
  }, [latitude, longitude]);

  // Progress smoothing (unchanged)
  const lastProgressTsRef = useRef(0);
  const lastPercentRef = useRef(0);
  const THROTTLE_MS = 120;
  const progressTargetRef = useRef(0);
  const smoothProgressRef = useRef(0);
  const animatingRef = useRef(false);
  const startProgressAnimation = () => {
    if (animatingRef.current) return;
    animatingRef.current = true;
    const step = () => {
      const target = progressTargetRef.current;
      const current = smoothProgressRef.current;
      const delta = target - current;
      if (Math.abs(delta) < 0.5) {
        smoothProgressRef.current = target;
        setUiProgress(target);
        animatingRef.current = false;
        if (target >= 100) {
          setTimeout(() => {
            progressTargetRef.current = 0;
            smoothProgressRef.current = 0;
            setUiProgress(0);
            lastPercentRef.current = 0;
          }, 800);
        }
        return;
      }
      const inc = Math.max(0.5, delta * 0.15);
      smoothProgressRef.current = Math.min(100, current + inc);
      setUiProgress(Math.min(100, smoothProgressRef.current));
      requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  };
  const pushProgress = (percent) => {
    const now = performance.now();
    if (
      percent < 100 &&
      now - lastProgressTsRef.current < THROTTLE_MS &&
      percent - lastPercentRef.current < 2
    )
      return;
    lastProgressTsRef.current = now;
    if (percent - lastPercentRef.current >= 1 || percent === 100) {
      lastPercentRef.current = percent;
      setUploadPercentage(percent);
    }
    progressTargetRef.current = percent;
    startProgressAnimation();
  };

  // Cancel upload with util
  const cancelUpload = () => {
    try {
      uploader.cancel();
    } catch {}
    setError('Upload canceled.');
    setIsFetching(false);
    progressTargetRef.current = 0;
    smoothProgressRef.current = 0;
    animatingRef.current = false;
    setUiProgress(0);
    setUploadPercentage(0);
  };

  const stageFiles = (selected) => {
    const list = Array.from(selected || []);
    if (!list.length) return;
    const next = [];
    const errs = [];
    list.forEach((f) => {
      try {
        uploader.validate(f);
        const preview = URL.createObjectURL(f);
        next.push({
          file: f,
          preview,
          isVideo: isVideoFile(f.name.toLowerCase()),
        });
      } catch (err) {
        errs.push(err.message || `${f.name} is not valid.`);
      }
    });
    if (errs.length) setError(errs.join(' | '));
    else setError('');
    setFiles((prev) => {
      const merged = [...prev, ...next];
      if (merged.length > MAX_MEDIA_COUNT) {
        const trimmed = merged.slice(0, MAX_MEDIA_COUNT);
        merged.slice(MAX_MEDIA_COUNT).forEach((d) => {
          if (d.preview?.startsWith('blob:')) URL.revokeObjectURL(d.preview);
        });
        return trimmed;
      }
      return merged;
    });
    if (fileInput.current) fileInput.current.value = null;
  };

  // Unified file input handler using uploader.validate
  const handleFileInput = (e) => {
    stageFiles(e.target.files);
  };

  const onDragOver = (ev) => {
    ev.preventDefault();
    dndRef.current?.classList.add('dndHover');
  };
  const onDragLeave = (ev) => {
    ev.preventDefault();
    dndRef.current?.classList.remove('dndHover');
  };
  const onDrop = (ev) => {
    ev.preventDefault();
    dndRef.current?.classList.remove('dndHover');
    if (ev.dataTransfer?.files?.length) {
      stageFiles(ev.dataTransfer.files);
    }
  };

  const shareJGHandler = async (e) => {
    e.preventDefault();
    setIsFetching(true);
    try {
      await axiosConn.post(
        '/invites',
        {
          player: player.data.player._id,
          firstName: namer,
          emailAddress: emailr,
        },
        { headers: { Authorization: `Bearer ${player.token}` } },
      );
      resetForm();
      showConfettiText2();
    } catch (err) {
      resetForm();
      setError(err.message || 'Invite failed');
    }
  };

  // Derive whether the post (non-invite) is empty: no text AND no media
  const isPostEmpty = useMemo(
    () =>
      shareJG === 0 &&
      descr.trim() === '' &&
      files.length === 0 &&
      !forcedImgUrl,
    [shareJG, descr, files.length, forcedImgUrl],
  );

  const submitHandler = async (e) => {
    e.preventDefault();
    setIsFetching(true);
    setError('');

    if (isPostEmpty) {
      setError('Add text or attach media before sharing.');
      setIsFetching(false);
      return;
    }

    if (desc.current) desc.current.value = descr;

    const suspended = await handleSuspension(
      shareTimestamps,
      setCommentTimestamps,
      setIsSuspended,
      SHARE_LIMIT,
      TIME_FRAME,
      SUSPENSION_TIME,
      player.data.player._id,
    );
    if (suspended || isSuspended) {
      setIsFetching(false);
      setError('You are temporarily suspended from posting. Try later.');
      return;
    }

    try {
      let mediaUrls = [];
      if (files.length) {
        for (const item of files) {
          try {
            uploader.validate(item.file);
          } catch (err) {
            setError(err.message || 'Invalid file.');
            setIsFetching(false);
            return;
          }
        }
        for (const item of files) {
          const { transformedUrl } = await uploader.upload(item.file, {
            onProgress: (pct) => pushProgress(pct),
            publicIdPrefix: 'Images',
          });
          mediaUrls.push({
            url: transformedUrl,
            type: item.isVideo ? 'video' : 'image',
          });
        }
      } else if (forcedImgUrl) {
        mediaUrls = [
          { url: forcedImgUrl, type: isVideoSrc(forcedImgUrl) ? 'video' : 'image' },
        ];
      }
      const imgUrl = mediaUrls[0]?.url || forcedImgUrl || null;

      if (parent === 'galaxy') {
        await createGalaxyPost(imgUrl, mediaUrls);
      } else {
        await createPost(imgUrl, mediaUrls);
      }
      handleClearLocation();
      resetForm();
      onSubmitSuccess && onSubmitSuccess();
    } catch (err) {
      handleClearLocation();
      if (err.message !== 'Upload canceled.')
        setError(err.message || 'Upload failed');
      setIsFetching(false);
    } finally {
      setIsFetching(false);
    }
  };

  const handleProofOfGreatWorkCheck = () => SetPogw((p) => !p);

  const previewItems = useMemo(() => {
    if (files.length) return files;
    if (forcedImgUrl)
      return [
        { preview: forcedImgUrl, isVideo: isVideoSrc(forcedImgUrl), forced: true },
      ];
    return [];
  }, [files, forcedImgUrl]);

  return (
    <div
      className={darkTheme ? 'shareDarkTheme' : 'share'}
      ref={dndRef}
      onDragOver={onDragOver}
      onDragLeave={onDragLeave}
      onDrop={onDrop}
    >
      <LoadingBar
        color="limegreen"
        progress={uiProgress}
        onLoaderFinished={() => {}}
        shadow={false}
        loaderSpeed={400}
        height={3}
        style={{ visibility: uiProgress > 0 ? 'visible' : 'hidden' }}
      />
      <div className="shareWrapper">
        <div className={!mobileView ? 'shareTop' : 'shareTopMobile'}>
          <img
            className={
              !mobileView ? 'shareProfileImg' : 'shareProfileImgMobile'
            }
            src={
              player.data.player.profilePhoto
                ? player.data.player.profilePhoto
                : 'https://res.cloudinary.com/joegalaxy/image/upload/q_auto/v1656194537/Images/noAvatar_tsgpm9.png'
            }
            alt=""
            loading="lazy"
          />
          {shareJG === 1 ? (
            <div className="shareJG">
              <div className="shareJGName">
                <div
                  className={
                    !mobileView
                      ? 'share_jg_comment_input_wrap'
                      : 'shareJG_wrapMobile'
                  }
                >
                  <input
                    required
                    className="loginInput"
                    type="text"
                    ref={nameRef}
                    value={namer}
                    placeholder="First Name"
                    disabled={isFetching}
                    onChange={(e) => setNamer(e.target.value)}
                  />
                </div>
              </div>
              <div className="shareJGName">
                <div
                  className={
                    !mobileView
                      ? 'share_jg_comment_input_wrap'
                      : 'shareJG_wrapMobile'
                  }
                >
                  <input
                    type="email"
                    required
                    className="loginInput"
                    ref={emailRef}
                    value={emailr}
                    placeholder="Email Address"
                    disabled={isFetching}
                    onChange={(e) => setEmailr(e.target.value)}
                  />
                </div>
              </div>
            </div>
          ) : (
            <div
              className={
                !mobileView ? 'comment_input_wrap' : 'shareMessage_wrapMobile'
              }
            >
              <input
                disabled={isDisabled || isFetching}
                type="text"
                ref={desc}
                value={descr}
                placeholder={`What's on your mind ${player.data.player.playerId}?`}
                onChange={(e) => {
                  const v = e.target.value;
                  setDescr(v.length > 4096 ? v.slice(0, 4096) : v);
                }}
              />
              {!mobileView && (
                <p
                  style={{ color: descr.length <= 4096 ? 'limegreen' : 'red' }}
                >
                  {4096 - descr.length}
                </p>
              )}
              <div className="comment_circle" style={{ marginTop: '5px' }}>
                <ClipLoader size={10} color="#1876f2" loading={isFetching} />
              </div>
              <div
                ref={emojiBtnRef}
                className="comment_circle_icon hover2 emojiTrigger"
                onClick={() => !isFetching && setPicker((p) => !p)}
                onKeyDown={(e) => {
                  if (isFetching) return;
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    setPicker((p) => !p);
                  } else if (e.key === 'Escape') {
                    setPicker(false);
                  }
                }}
                role="button"
                tabIndex={0}
                aria-haspopup="dialog"
                aria-expanded={picker}
                aria-label="Add emoji"
              >
                <i className="emoji_icon"></i>
                <span className="emojiPulse" aria-hidden="true"></span>
              </div>
              <div
                className="comment_circle_icon hover2"
                onClick={() => !isFetching && fileInput.current?.click()}
              >
                <i className="addPhoto_icon"></i>
              </div>
            </div>
          )}
        </div>

        <div
          className="shareHint"
          aria-hidden="true"
          style={{
            fontSize: '12px',
            color: '#7a7a7a',
            marginTop: '8px',
            marginBottom: '8px',
            paddingLeft: !mobileView ? 72 : 0,
            pointerEvents: 'none',
          }}
        >
          Drag & drop up to 10 images, or tap + to add. Multi-image posts are
          supported.
        </div>

        {shareJG === 1 && (
          <span className="shareJGText">
            You Receive {sendReferralEmailJGKRate} $JGK for Inviting and{' '}
            {usdJGKConversionRate} $JGK on Conversion!
          </span>
        )}

        {latitude && longitude && (
          <div className="centeredLocation">
            <Room htmlColor="green" className="shareIcon" />
            <EasyEdit
              value={address || 'city, state, country?'}
              type="text"
              onSave={(v) => setAddress(v)}
              onCancel={() => {}}
              saveOnBlur
              attributes={{ name: 'address-input', id: 1 }}
              className="profileInfoDesc"
            />
            <CloseIcon
              className="clearLocation"
              onClick={handleClearLocation}
            />
          </div>
        )}

        <hr className="shareHr" ref={shareRef} />
        <ConfettiTextComponent />

        {error && (
          <div className="shareError_error">
            <div className="error_text">{error}</div>
            <div style={{ display: 'flex', gap: 8 }}>
              <button
                className="blue_btn"
                onClick={() => {
                  setError('');
                  files.forEach((f) => {
                    if (f.preview?.startsWith('blob:')) URL.revokeObjectURL(f.preview);
                  });
                  setFiles([]);
                  if (fileInput.current) fileInput.current.value = null;
                  setIsFetching(false);
                }}
              >
                Reset
              </button>
              {isFetching && (
                <button className="blue_btn" onClick={cancelUpload}>
                  Cancel
                </button>
              )}
            </div>
          </div>
        )}

        {previewItems.length > 0 && (
          <div className="shareMultiPreview">
            {previewItems.map((item, idx) =>
              item.isVideo ? (
                <div className="shareVidContainer" key={item.preview || idx}>
                  <video
                    className="postVid"
                    controls
                    muted
                    playsInline
                    preload="metadata"
                    src={item.preview}
                    style={{ maxHeight: 400 }}
                  />
                  {!item.forced && (
                    <Cancel
                      disabled={isFetching}
                      className="shareCancelVid"
                      onClick={() => {
                        if (isFetching) cancelUpload();
                        setIsFetching(false);
                        setFiles((prev) => {
                          const next = prev.filter((f) => f.preview !== item.preview);
                          if (item.preview?.startsWith('blob:'))
                            URL.revokeObjectURL(item.preview);
                          return next;
                        });
                        if (fileInput.current) fileInput.current.value = null;
                      }}
                    />
                  )}
                </div>
              ) : (
                <div className="shareImgContainer" key={item.preview || idx}>
                  <img
                    className="shareImg"
                    src={item.preview}
                    alt="Preview"
                    loading="lazy"
                  />
                  {!item.forced && (
                    <Cancel
                      disabled={isFetching}
                      className="shareCancelImg"
                      onClick={() => {
                        if (isFetching) cancelUpload();
                        setIsFetching(false);
                        setFiles((prev) => {
                          const next = prev.filter((f) => f.preview !== item.preview);
                          if (item.preview?.startsWith('blob:'))
                            URL.revokeObjectURL(item.preview);
                          return next;
                        });
                        if (fileInput.current) fileInput.current.value = null;
                      }}
                    />
                  )}
                </div>
              ),
            )}
          </div>
        )}

        {files.length > 0 && isFetching && (
          <div className="uploadProgressMeta">
            <div className="uploadProgressBarOuter">
              <div
                className="uploadProgressBarInner"
                style={{ width: `${uploadPercentage}%` }}
              />
            </div>
            <span className="uploadProgressLabel">
              {uploadPercentage}%{' '}
              {uploadPercentage < 100 ? 'Uploading...' : 'Processing...'}
            </span>
            <button
              type="button"
              className="cancelUploadBtn"
              onClick={cancelUpload}
              disabled={uploadPercentage >= 99}
            >
              Cancel
            </button>
          </div>
        )}

        <form
          className="shareBottom"
          onSubmit={shareJG === 1 ? shareJGHandler : submitHandler}
        >
          <div className="shareOptions">
            <label htmlFor="file" className="shareOption">
              <PermMedia
                htmlColor={shareJG === 1 || isDisabled ? 'grey' : 'tomato'}
                className={!mobileView ? 'shareIcon' : 'shareIconMobile'}
                style={
                  width > 519 ? { fontSize: '35px' } : { fontSize: '25px' }
                }
              />
              <input
                ref={fileInput}
                type="file"
                style={{ display: 'none' }}
                id="file"
                accept={FILE_ACCEPT}
                multiple
                onChange={handleFileInput}
                disabled={shareJG === 1 || isDisabled || isFetching}
              />
            </label>

            <ConfettiTextComponent2 />
            <div ref={inputRef2}>
              <ShareJGButton
                pogw={pogw}
                handleShareJGToggle={handleShareJGToggle}
                shareJG={shareJG}
                mobileView={mobileView}
                width={width}
                color="#9c27b0"
              />
            </div>

            <div className="shareOption">
              <Room
                htmlColor="green"
                className="shareIcon"
                onClick={() => !isFetching && handleGetLocation()}
                style={{ cursor: isFetching ? 'not-allowed' : 'pointer' }}
              />
              {width >= 440 && (
                <span className="shareOptionText">Location</span>
              )}
            </div>

            {/* POGW pill */}
            <div className="shareOption pogwPill">
              <label className="pogwCheckbox" htmlFor="pogw-checkbox">
                <input
                  id="pogw-checkbox"
                  type="checkbox"
                  checked={pogw}
                  disabled={shareJG === 1 || isFetching}
                  onChange={handleProofOfGreatWorkCheck}
                  aria-label="Mark post as Proof of Great Work"
                />
                <span className="pogwFake" aria-hidden="true"></span>
              </label>
              <button
                type="button"
                className="pogwTrophyBtn"
                tabIndex={0}
                aria-describedby={!pogw && width > 280 ? 'pogw-tip' : undefined}
                disabled={isFetching}
              >
                <EmojiEventsOutlinedIcon className="pogwTrophyIcon" />
                {!pogw && width > 280 && (
                  <span
                    id="pogw-tip"
                    role="tooltip"
                    className="pogwTooltipContent"
                  >
                    <strong>POGW</strong> = Proof of Great Work.
                    <br />
                    Evidence of value & Klout. Mark to enable JGK rewards.
                  </span>
                )}
              </button>
            </div>

            <button
              className={
                !mobileView
                  ? readyToShareJG || shareJG === 0
                    ? 'animated-subscribe-btn shareButton'
                    : 'shareButtonDisabled'
                  : readyToShareJG || shareJG === 0
                  ? 'animated-subscribe-btn shareButtonMobile'
                  : 'shareButtonMobileDisabled'
              }
              type="submit"
              disabled={
                isFetching ||
                (shareJG === 1 && !readyToShareJG) ||
                (parent === 'galaxy' && galaxyMember === false) ||
                isPostEmpty
              }
              title={
                isPostEmpty
                  ? 'Add text or media to share'
                  : shareJG === 1 && !readyToShareJG
                  ? 'Enter valid name & email to invite'
                  : undefined
              }
            >
              {isFetching ? (
                <CircularProgress color="inherit" size="20px" />
              ) : (
                'Share'
              )}
            </button>
          </div>
        </form>
      </div>

      {picker &&
        createPortal(
          <div
            ref={pickerRef}
            className={`emojiPortal ${
              pickerPos.placement === 'above'
                ? 'emojiPortal--above'
                : 'emojiPortal--below'
            }`}
            style={{ top: pickerPos.top, left: pickerPos.left }}
            role="dialog"
            aria-modal="false"
            aria-label="Emoji picker"
          >
            <div className="emojiPortalHeader">
              <span className="emojiPortalTitle">Emoji</span>
              <button
                type="button"
                className="emojiCloseBtn"
                aria-label="Close emoji picker"
                onClick={() => setPicker(false)}
              >
                ×
              </button>
            </div>
            <div className="emojiPortalBody">
              <Picker
                onEmojiClick={handleEmoji}
                theme={darkTheme ? 'dark' : 'light'}
                lazyLoadEmojis
                searchDisabled={false}
                autoFocus
              />
            </div>
          </div>,
          document.body,
        )}
    </div>
  );
}, arePropsEqual);
